import React from "react";
import PropTypes from "prop-types";
import UIUserInfo from "../UIUserInfo";

const UIActionModalUserInfo = ({
  name,
  description,
  image,
  initials,
  maxInitials,
  children,
}) => (
  <UIUserInfo
    name={name}
    description={description}
    image={image}
    initials={initials}
    maxInitials={maxInitials}
  >
    {children}
  </UIUserInfo>
);


export default UIActionModalUserInfo;

UIActionModalUserInfo.propTypes = {
  name: PropTypes.node.isRequired,
  description: PropTypes.node,
  image: PropTypes.string,
  initials: PropTypes.string,
  maxInitials: PropTypes.number,
  children: PropTypes.node,
};

UIActionModalUserInfo.defaultProps = {
  description: null,
  image: undefined,
  initials: "",
  maxInitials: 2,
  children: null,
};